import { useHerds } from 'app/agriculture/queries/herds/useHerds';
import { useSnapshots } from 'app/agriculture/queries/snapshots/useSnapshots';
import { useMemo } from 'react';
import { Herd } from 'app/agriculture/queries/herds/types/Herd';

/**
 * Returns an array of herds that are attached to a specific entity
 *
 * @param entityId
 */
export function useHerdsForEntity(entityId: string) {
    const herds = useHerds();
    const snapshots = useSnapshots({ snapshotType: 'Herd', shelfLife: null });

    const herdsByPaddockId = useMemo(() => {
        const map = new Map<string, Herd[]>();
        for (const herd of herds.values()) {
            const { paddockId } = snapshots.get(herd.id) ?? {};
            if (paddockId != null) {
                map.set(paddockId, [...(map.get(paddockId) ?? []), herd]);
            }
        }
        return map;
    }, [herds, snapshots]);

    return useMemo(() => herdsByPaddockId.get(entityId) ?? [], [herdsByPaddockId, entityId]);
}
